import {Component, ElementRef, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren} from '@angular/core';
import { AppService, Term, Metric, MetricValue, Period, MetricType, Usermeta } from './services/app.service';
import {ActivatedRoute} from '@angular/router';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { fromEvent, Observable, Subscription } from 'rxjs';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {formatDate} from '@angular/common';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  customPatterns = {
    'V': {pattern: new RegExp('[-?0-9]')},
    '0': {pattern: new RegExp('[0-9]')}
  };
  constructor(public appService: AppService, private route: ActivatedRoute, private host: ElementRef, private sanitizer: DomSanitizer){
    window.addEventListener('message', data => {
      if (data.data.windowHeight) {
        this.currentScrollPosition = data.data.scrollTop - data.data.iframePosition;
        if (this.currentScrollPosition < 0){
          this.currentScrollPosition = 0;
        }
      }
    }, false);
    this.route.queryParams.subscribe(params => {
      if (params.url){
        appService.setApiUrl(params.url);
      }
      else{
        return;
      }
      this.appService.checkLogin().subscribe(response => {
        if (response.status){
          this.isPublic = params.public ? true : false;
          this.isAuthenticated = params.is_authenticated ? true : false;
          this.theme = params.theme ? params.theme : 'default';
          this.kfSso = response.kfSso ? response.kfSso : '';
          this.kfCompany = response.kfCompany ? response.kfCompany : '';
          this.ssoRedirect = response.ssoRedirect ? response.ssoRedirect : '';
          if ( params.primary_color ){
            document.documentElement.style.setProperty('--primary-color', '#' + params.primary_color);
            document.documentElement.style.setProperty('--primary-color-transparent',
              'rgba(' + parseInt(params.primary_color.substring(0, 2), 16) + ',' + parseInt(params.primary_color.substring(2, 4), 16) + ',' + parseInt(params.primary_color.substring(4, 6), 16) + ',0.2)');
          }
          if ( params.transparent ){
            document.documentElement.style.setProperty('--background-color', 'transparent');
          }
          this.iframeId = 'v' + params.v;
          this.userId = params.user_id ? params.user_id : 0;
          if (params.hideGoal){
            this.hideGoal = true;
          }
          if (params.hasPeriodGoal){
            this.hasPeriodGoal = true;
          }
          if (params.hideVitalStats){
            this.hideVitalStats = true;
          }
          if (params.hideSettings){
            this.hideSettings = true;
          }
          if (params.compactMetrics){
            this.compactMetrics = JSON.parse(params.compactMetrics);
          }
          else{
            this.compactMetrics = [];
          }
          if (params.post){
            this.post = params.post;
            this.appService.getSettings(this.post, this.userId).subscribe(response => {
              this.goalsRequired = response.goalsRequired;
              this.actualsRequired = response.actualsRequired;
              if (response.terms.length > 0){
                this.terms = response.terms.map(term => {
                  term.startDateUTC = new Date(Date.UTC(term.startDate.y, term.startDate.m, term.startDate.d));
                  term.startDate = new Date(term.startDate.y, term.startDate.m, term.startDate.d, 0, 0, 0, 0);
                  term.endDateUTC = new Date(Date.UTC(term.endDate.y, term.endDate.m, term.endDate.d));
                  term.endDate = new Date(term.endDate.y, term.endDate.m, term.endDate.d, 0, 0, 0, 0);
                  return term;
                });
              }
              else{
                this.terms.push(this.appService.getDefaultTerm());
              }
              if (response.businesses.length > 0){
                this.businesses = response.businesses;
              }
              this.usermeta = response.usermeta;
              this.getMetrics();
              this.setPeriods();
              if (params.compact || this.theme === 'boardroom' || this.theme === 'outcomes'){
                if(params.compact){
                  this.isCompact =  true;
                }
                let today = new Date();
                let i = 0;
                let abort = false;
                for (const term of this.terms){
                  if(abort){
                    break;
                  }
                  today = new Date();
                  if ( !term.period ){
                    today = new Date( today.getFullYear(), today.getMonth(), 0, 0, 0, 0);
                  }
                  const periods = this.appService.getPeriods(term);
                  periods.reverse();
                  let j = periods.length - 1;
                  for (const period of periods){
                    if(abort){
                      break;
                    }
                    if (period.date < today){
                      this.updateSelectedIndex(i);
                      this.currentPeriodIndex = j;
                      this.todayTermIndex = i;
                      this.todayPeriodIndex = j;
                      if(this.hasPeriodGoal){
                        this.goalTermIndex = i;
                        this.goalPeriods = [period];
                      }
                      else{
                        if( j === periods.length - 1 && i > 0 ){
                          this.goalTermIndex = i - 1;
                        }
                        else{
                          this.goalTermIndex = i;
                        }
                        this.goalPeriods = this.appService.getPeriods(this.terms[this.goalTermIndex]);
                      }
                      abort = true;
                      break;
                    }
                    j--;
                  }
                  i++;
                  /*if (term.startDate > today || term.endDate > today){
                    this.updateSelectedIndex(i);
                    this.todayTermIndex = i;
                    this.goalTermIndex = this.selectedTermIndex;
                    let j = 0;
                    for (const period of this.periods){
                      if (period.date >= this.today){
                        this.currentPeriodIndex = j - 1;
                        this.todayPeriodIndex = j - 1;
                        if (this.currentPeriodIndex === -1){
                          if (i > 0){
                            this.updateSelectedIndex(i - 1);
                            this.currentPeriodIndex = this.periods.length - 1;
                            this.todayPeriodIndex = this.periods.length - 1;
                            this.todayTermIndex = i - 1;
                            if(this.goalTermIndex > 0){
                              this.goalTermIndex = this.goalTermIndex - 1;
                            }
                          }
                        }
                        break;
                      }
                      j++;
                    }
                  }
                  break;*/
                }
                if (this.currentPeriodIndex === -1){
                  this.updateSelectedIndex(0);
                  this.currentPeriodIndex = this.periods.length - 1;
                  this.todayPeriodIndex = this.periods.length - 1;
                  this.goalTermIndex = 0;
                }
              }
            });
            if (this.isPublic){
              this.appService.getValues(this.post, this.userId).subscribe(metricValues => {
                this.metricValues = metricValues;
              });
            }
          }
          else{
            this.terms.push(this.appService.getDefaultTerm());
            this.getMetrics();
            this.setPeriods();
          }
        }
        else{
          this.isLoggedIn = false;
          this.loginMessage = this.sanitizer.bypassSecurityTrustHtml( response.message );
        }
      });
    });
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.resizeSubscription$ = this.resizeObservable$.subscribe( evt => {
      this.resizeIframe();
    });
  }
  title = 'Record-Component';
  @ViewChild('app')
  appContainer: ElementRef;
  @ViewChild('settingContainerAdmin')
  settingContainerAdmin: ElementRef;
  @ViewChild('settingContainerPublic')
  settingContainerPublic: ElementRef;

  public businesses: any = [];

  public appLoaded = false;
  public currentScrollPosition = 0;
  public post: number;
  public userId: number;
  public isPublic: boolean;
  public isCompact: boolean;
  public theme: string;
  public hideGoal = false;
  public hideVitalStats = false;
  public hideSettings = false;
  public compactMetrics: number[];
  public popup: boolean;
  public popupIndex: number;
  public showDropdown = false;
  public terms: Term[] = [];
  public usermeta: Usermeta[] = [];
  public periods: Period[] = [];
  public metricValues = {};
  public progressBarSelected = {};
  public selectedTermIndex = 0;
  public selectedBusinessIndex = 0;
  public goalTermIndex = 0;
  public goalPeriods: Period[] = [];
  public message: string;
  public today: Date = new Date();
  public metrics: Metric[];
  public processing = false;
  public notification = {
    type: 0,
    text: ''
  };
  public goalScreenActive = false;
  public settingsScreenActive = false;
  public screenWidth: number;
  public ssoRetried = 0;
  public ssoProcessing = false;
  public metricTypes: MetricType[] = [
    {
      name: 'currency',
      symbol: '$'
    },
    {
      name: 'number',
      symbol: '#'
    },
    {
      name: 'percentage',
      symbol: '%'
    },
    {
      name: 'text',
      symbol: 'T'
    },
    {
      name: 'progress',
      symbol: '✓'
    },
    {
      name: 'dropdown-list',
      symbol: '☰'
    }
  ];
  public showToolTip = '';
  public showTypeSelector = -1;
  public showDecimalDigitsSelector = -1;
  public showOptionBox = -1;
  public showGoalTypeSelector = -1;
  resizeObservable$: Observable<Event>;
  resizeSubscription$: Subscription;
  public iframeId = '';
  public showCopyPopup = '';
  public showCopyOffset = 0;
  public copyOption = '0';
  public copyOptionAmount = 0;
  public copyOptionPercent = 0;
  public isAuthenticated = false;
  public kfSso: string;
  public kfCompany: string;
  public ssoRedirect: string;
  public isLoggedIn = true;
  public loginMessage: SafeHtml = '';
  public currentPeriodIndex = -1;
  public todayPeriodIndex = -1;
  public todayTermIndex = 0;
  public lastMonth = 1;
  public goalsRequired = false;
  public actualsRequired = false;
  public hasPeriodGoal = false;
  @ViewChildren('metricsLoop') metricsLoop: QueryList<any>;
  resizeIframe(): void{
    if (window !== top){
      window.top.postMessage( {iframeId: this.iframeId, iframeHeight: this.appContainer.nativeElement.offsetHeight }, location.origin );
    }
  }
  dropTerms(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.terms, event.previousIndex, event.currentIndex);
    this.selectedTermIndex = event.currentIndex;
  }
  dropMetrics(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.terms[this.selectedTermIndex].metrics, event.previousIndex, event.currentIndex);
  }
  dropBusinesses(event: CdkDragDrop<string[]>): void {
    moveItemInArray(this.businesses, event.previousIndex, event.currentIndex);
    this.selectedBusinessIndex = event.currentIndex;
  }
  updateShowToolTip(str): void{
    if ( this.showToolTip === str ){
      this.showToolTip = '';
    }
    else{
      this.showToolTip = str;
    }
  }
  updateShowTypeSelector(i): void{
    if ( this.showTypeSelector === i ){
      this.showTypeSelector = -1;
    }
    else{
      this.showTypeSelector = i;
    }
  }
  updateShowDecimalDigitsSelector(i): void{
    if ( this.showDecimalDigitsSelector === i ){
      this.showDecimalDigitsSelector = -1;
    }
    else{
      this.showDecimalDigitsSelector = i;
    }
  }
  updateShowOptionBox(i): void{
    if ( this.showOptionBox === i ){
      this.showOptionBox = -1;
    }
    else{
      this.showOptionBox = i;
    }
  }
  updateShowGoalTypeSelector(i): void{
    if ( this.showGoalTypeSelector === i ){
      this.showGoalTypeSelector = -1;
    }
    else{
      this.showGoalTypeSelector = i;
    }
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
  }
  @HostListener('window:resize', ['$event'])
  onResize(event): void {
    this.screenWidth = window.innerWidth;
  }
  getMetrics(): void {
    /*this.metrics = [];
    this.appLoaded = true;
    return;*/
    this.appService.getMetrics(this.post).subscribe(metrics => {
      this.metrics = metrics;
      this.metrics.map((item) => {
        if (typeof item.decimalDigits === 'undefined'){
          item.decimalDigits = 2;
        }
        return item;
      });
      this.appLoaded = true;
      setTimeout(() => {
        this.resizeIframe();
      }, 3000);
    });
  }
  addBusiness(): void {
    if(!this.processing){
      this.processing = true;
      this.appService.addBusiness().subscribe((response: any) => {
        this.processing = false;
        this.businesses.push(response);
        this.selectedBusinessIndex = this.businesses.length - 1;
      });
    }
  }
  deleteBusiness(): void{
    if(!this.processing){
      if(confirm("Are you sure you want to delete this business?")){
        this.processing = true;
        this.appService.deleteBusiness(this.businesses[this.selectedBusinessIndex].id).subscribe((response: any) => {
          this.processing = false;
          this.businesses.splice(this.selectedBusinessIndex, 1);
          this.selectedBusinessIndex = this.businesses.length - 1;
        });
      }
    }
  }
  addTerm(): void {
    this.terms.push(this.appService.getDefaultTerm());
    this.selectedTermIndex = this.terms.length - 1;
    this.setPeriods();
  }
  cloneTerm(): void{
    const t = JSON.parse(JSON.stringify(this.terms[this.selectedTermIndex]));
    t.id = Math.floor(Math.random() * 100000);
    this.terms.push(t);
    this.selectedTermIndex = this.selectedTermIndex + 1;
    this.setPeriods();
  }
  updateSelectedIndex(i): void{
    this.selectedTermIndex = i;
    this.settingsScreenActive = false;
    this.setPeriods();
  }
  updateSelectedBusinessIndex(i): void{
    this.selectedBusinessIndex = i;
  }
  deleteTerm(): void {
    if (this.terms.length < 1) {
      return;
    }
    this.terms.splice(this.selectedTermIndex, 1);
    if (this.terms.length > this.selectedTermIndex) {
      this.selectedTermIndex++;
    }
    else{
      this.selectedTermIndex--;
    }
    this.setPeriods();
  }
  updateType(index, type): void {
    this.metrics[index].type = type;
  }
  updateDecimalDigits(index, decimalDigits): void {
    this.metrics[index].decimalDigits = decimalDigits;
  }
  updateGoalType(index, type): void {
    this.metrics[index].goalType = type;
  }
  saveSettings(): void {
    if (!this.processing){
      this.processing = true;
      this.appService.saveSettings(this.post ? this.post : 0, this.terms, this.metrics).subscribe(response => {
        this.processing = false;
        if (response.status){
          this.notification.type = 1;
          this.notification.text = 'Successfully Saved!';
          setTimeout(() => {
            this.notification.text = '';
          }, 3000);
          if (!this.post){
            window.top.location.href = this.appService.config.url + 'wp-admin/post.php?post=' + response.post + '&action=edit';
          }
        }
      });
    }
  }
  saveValues(): void{
    this.actualsRequired = true;
    if(this.goalsRequired || this.actualsRequired){
      let lastPeriod;
      for(const period of this.periods){
        if(period.date < this.today){
          lastPeriod = period;
          continue;
        }
        else{
          break;
        }
      }
      for(const metric of this.terms[this.selectedTermIndex].metrics){
        if(this.goalsRequired && lastPeriod) {
          for(const business of this.businesses){
            //if (!this.metricValues['b'+this.businesses[this.selectedBusinessIndex].id+'_m' + metric + '_t' + this.terms[this.selectedTermIndex].period + '_p' + lastPeriod.dateString + '_goal']) {
            if (!this.metricValues['b'+business.id+'_m' + metric + '_t' + this.terms[this.selectedTermIndex].period + '_p' + lastPeriod.dateString + '_goal']) {
              this.notification.type = 1;
              this.notification.text = 'Goals are required before actuals can be entered for the Business: ' + business.name;
              this.processing = false;
              setTimeout(() => {
                this.notification.text = '';
              }, 3000);
              return;
            }
          }
        }
        if(this.actualsRequired && !this.goalScreenActive) {
          for(const business of this.businesses){
            //if (!this.metricValues['b'+this.businesses[this.selectedBusinessIndex].id+'_m' + metric + '_t' + this.terms[this.selectedTermIndex].period + '_p' + lastPeriod.dateString + '_actual']) {
            if (!this.metricValues['b'+business.id+'_m' + metric + '_t' + this.terms[this.selectedTermIndex].period + '_p' + lastPeriod.dateString + '_actual']) {
              this.notification.type = 1;
              this.notification.text = 'Actuals are required for the Business: ' + business.name;
              this.processing = false;
              setTimeout(() => {
                this.notification.text = '';
              }, 3000);
              return;
            }
          }
        }
      }
    }
    if (!this.processing) {
      this.processing = true;
      this.appService.saveValues(this.post, this.userId, this.metricValues, this.businesses, this.goalScreenActive).subscribe(response => {
        if (response.status) {
          this.notification.type = 1;
          this.notification.text = 'Successfully Saved!';
          this.processing = false;
          setTimeout(() => {
            this.notification.text = '';
          }, 3000);
        }
      });
    }
  }
  setPeriods(): void{
    this.periods = this.appService.getPeriods(this.terms[this.selectedTermIndex]);
    this.today = new Date();
    if ( !this.terms[this.selectedTermIndex].period ){
      this.today = new Date( this.today.getFullYear(), this.today.getMonth(), 0, 0, 0, 0);
    }
  }
  addMetric(index: number = -1): void {
    if (index === -1){
      /*const id = Math.floor(Math.random() * 100000);
      this.metrics.push({
        id: id,
        title: 'Test Title',
        type: 0,
        hasGoal: false,
        editable: false
      });
      this.terms[this.selectedTermIndex].metrics.push( id );
      this.showDropdown = false;
      return;*/
      this.appService.newMetric().subscribe(response => {
        if (response.status){
          this.metrics.push(response.metric);
          this.terms[this.selectedTermIndex].metrics.push( response.metric.id );
        }
      });
    }
    else{
      this.terms[this.selectedTermIndex].metrics.push( this.metrics[index].id );
    }
    this.showDropdown = false;
  }
  deleteMetric(index): void{
    if (confirm('Are you sure you want to delete this metric?')){
      this.terms[this.selectedTermIndex].metrics.splice(index, 1);
    }
  }
  getMetricIndex(id): number{
    return this.metrics.findIndex(function(metric){
      return metric.id === id;
    });
  }
  toggleGoals(value: boolean): void{
    this.goalScreenActive = value;
  }
  toggleSettings(): void{
    this.settingsScreenActive = !this.settingsScreenActive;
  }
  saveUserSettings(): void{
    if (!this.processing) {
      this.processing = true;
      this.appService.saveUserSettings(this.usermeta, this.userId).subscribe(response => {
        if (response.status) {
          this.notification.type = 1;
          this.notification.text = 'Successfully Saved!';
          this.processing = false;
          setTimeout(() => {
            this.notification.text = '';
          }, 3000);
        }
      });
    }
  }
  @HostListener('click', ['$event'])
  hideProgressBars(): void{
    const target = event.target as Element;
    if (!target.classList.contains('progress-input-field') && !target.classList.contains('progress-input') && !target.closest('.progress-input')){
      this.progressBarSelected = {};
    }
    if (target.classList.contains('tooltip') && !target.closest('.tooltip')) {
      this.showToolTip = '';
    }
  }
  setShowCopyPopup(metric, offset): void{
    this.showCopyPopup = metric;
    this.showCopyOffset = offset;
  }
  applyFormula(): void{
    let i = 0;
    for (const period of this.periods){
      i++;
      if ( i <= this.showCopyOffset + 1 ){
        continue;
      }
      let val = 0;
      let out = '';
      switch (this.copyOption){
        case '0':
          val = this.metricValues[
          'b'+this.businesses[this.selectedBusinessIndex].id+'_m' + this.showCopyPopup + '_t' +
          this.terms[this.selectedTermIndex].period + '_p' + this.periods[this.showCopyOffset].dateString + '_goal'
            ];
          out = val + '';
          break;
        case '1':
          val = Number( this.metricValues[
          'b'+this.businesses[this.selectedBusinessIndex].id+'_m' + this.showCopyPopup + '_t' + this.terms[this.selectedTermIndex].period + '_p' + this.periods[i - 2].dateString + '_goal'
            ] ) + Number( this.copyOptionAmount );
          out = Number(val.toFixed(2)).toString();
          break;
        case '2':
          val = Number( this.metricValues[
          'b'+this.businesses[this.selectedBusinessIndex].id+'_m' + this.showCopyPopup + '_t' + this.terms[this.selectedTermIndex].period + '_p' + this.periods[i - 2].dateString + '_goal'
            ] );
          val = val + val * Number( this.copyOptionPercent ) / 100 ;
          out = Number(val.toFixed(2)).toString();
          break;
      }
      this.metricValues[
      'b'+this.businesses[this.selectedBusinessIndex].id+'_m' + this.showCopyPopup + '_t' + this.terms[this.selectedTermIndex].period + '_p' + period.dateString + '_goal'
        ] = out;
    }
    this.showCopyPopup = '';
  }
  toggleProgressBar(key: string): void{
    const temp = this.progressBarSelected[key];
    this.progressBarSelected = {};
    this.progressBarSelected[key] = !temp;
  }
  ssoLogin(): void{
    this.ssoProcessing = true;
    this.appService.ssoLogin(this.kfSso, this.kfCompany).subscribe(response => {
      this.ssoProcessing = false;
      window.open(this.ssoRedirect, '_blank');
    },
      error => {
        this.appService.checkLogin().subscribe(response => {
          if (response.status) {
            this.kfSso = response.kfSso ? response.kfSso : '';
            this.kfCompany = response.kfCompany ? response.kfCompany : '';
            this.ssoRedirect = response.ssoRedirect ? response.ssoRedirect : '';
            if(this.ssoRetried < 4){
              this.ssoRetried++;
              this.ssoLogin();
            }
          }
          else{
            this.isLoggedIn = false;
            this.loginMessage = this.sanitizer.bypassSecurityTrustHtml( response.message );
          }
        });
      });
  }
  hasPreviousPeriod(): boolean{
    return (this.theme!='boardroom' || this.lastMonth < 5) && (
        this.currentPeriodIndex > 0 || this.selectedTermIndex < this.terms.length - 1
      );
  }
  hasNextPeriod(): boolean{
    return this.periods.length - 1 > this.currentPeriodIndex &&
      this.periods[this.currentPeriodIndex + 1].date < this.today ||
      (this.periods.length - 1) === this.currentPeriodIndex &&
      this.selectedTermIndex > 0 &&
      this.today > this.appService.getPeriods(this.terms[this.selectedTermIndex - 1])[0].date;
  }
  setPreviousPeriodIndex(): void{
    if (this.hasPreviousPeriod()){
      this.lastMonth++;
      if (this.currentPeriodIndex > 0){
        this.currentPeriodIndex--;
        if(this.hasPeriodGoal){
          this.goalPeriods = [this.periods[this.currentPeriodIndex]]
        }
      }
      else{
        this.updateSelectedIndex(this.selectedTermIndex + 1);
        this.currentPeriodIndex = this.periods.length - 1;
        if(this.hasPeriodGoal){
          this.goalTermIndex = this.selectedTermIndex;
          this.goalPeriods = [this.periods[this.currentPeriodIndex]]
        }
      }
    }
  }
  setNextPeriodIndex(): void{
    if (this.hasNextPeriod()){
      this.lastMonth--;
      if (this.periods.length - 1 > this.currentPeriodIndex){
        this.currentPeriodIndex++;
        if(this.hasPeriodGoal){
          this.goalPeriods = [this.periods[this.currentPeriodIndex]]
        }
      }
      else{
        this.updateSelectedIndex(this.selectedTermIndex - 1);
        this.currentPeriodIndex = 0;
        if(this.hasPeriodGoal){
          this.goalTermIndex = this.selectedTermIndex;
          this.goalPeriods = [this.periods[this.currentPeriodIndex]]
        }
      }
    }
  }
  missingValues(): string{
    let emptyPeriods = [];
    let currentPeriodIndex = this.todayPeriodIndex;
    let selectedTermIndex = this.todayTermIndex;
    let count = 0;
    while ( currentPeriodIndex > 0 || selectedTermIndex < this.terms.length - 1) {
      if (currentPeriodIndex > 0){
        currentPeriodIndex--;
      }
      else{
        selectedTermIndex++;
        currentPeriodIndex = this.periods.length - 1;
      }
      const periods = this.appService.getPeriods(this.terms[selectedTermIndex]);
      periods.reverse();
      for (const period of periods){
        if (period.date > this.today){
          continue;
        }
        count++;
        if (count > 5){
          continue;
        }
        for ( const metric of this.terms[selectedTermIndex].metrics ){
          if (!this.metricValues['b'+this.businesses[this.selectedBusinessIndex].id+'_m' + metric + '_t' + this.terms[selectedTermIndex].period + '_p' + period.dateString + '_actual']){
            const emptyPeriod = this.terms[selectedTermIndex].period ?
              (
                'Week' + formatDate(period.date, 'W', 'en-US') +
                (
                  formatDate(period.date, 'dd', 'en-US') +
                  (
                    period.date.getMonth() !== period.dateEnd.getMonth() ?
                      formatDate(period.date, 'MMM', 'en-US') :
                      ''
                  ) +
                  (
                    ' - ' +
                    formatDate(period.dateEnd, 'dd MMM', 'en-US')
                  )
                )
              ) :
              formatDate(period.date, 'MMM yyyy', 'en-US');
            if (emptyPeriods.indexOf(emptyPeriod) === -1){
              emptyPeriods.push(emptyPeriod);
            }
            break;
          }
        }
      }
    }
    return emptyPeriods.join(', ');
  }
  convertToOptions(text: string): string[]{
    return text ? text.split('\n').map(s => s.trim()) : [];
  }
  updateGoals(metric, periodType, dateString): void{
    if(!this.hasPeriodGoal){
      for (const period of this.goalPeriods){
        if (period.dateString !== dateString) {
          this.metricValues[ 'b'+this.businesses[this.selectedBusinessIndex].id+'_m' + metric + '_t' + periodType + '_p' + period.dateString + '_goal' ] =
            this.metricValues[ 'b'+this.businesses[this.selectedBusinessIndex].id+'_m' + metric + '_t' + periodType + '_p' + dateString + '_goal'];
        }
      }
    }
  }
  toNumber(a): number{
    return Number(a);
  }
  ngAfterViewInit(): void {
    this.metricsLoop.changes.subscribe(t => {
      this.resizeIframe();
    });
  }
}
